import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router-dom'
import flowRight from 'lodash/flowRight'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { colors } from 'shared'
//@ts-ignore
import withLivedata from 'shared/containers/withLivedata'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { translateCmd } from '../../../helpers'
import { formName, deleteClientRelationConfModal } from '../../../constants'
import { RelationsGridData, RelationsGridProps } from 'src/features/ClientDetails/types'
import { AppDispatch } from 'src/store'

function config(
  openDeleteClientRelationModal: (ID: number, HashSum_ClientID_: string, ClientID: number) => void,
  openDay: string,
  history: RouteComponentProps['history'],
) {
  return {
    gridIdentity: { formName, objectName: 'dbgrd_relations' },

    syncGridState: true,
    enableColumnsResize: true,
    enableColumnsOrder: true,
    enableRowSelection: true,

    columnConfigs: {
      RLDate: {
        valueFormatter: ({ value }: { value: string }) => dateFormatter(value),
      },
      RLDateEnd: {
        valueFormatter: ({ value }: { value: string }) => dateFormatter(value),
      },
    },

    getRowStyle: ({
      node: {
        data: { RelationID, RLDateEnd, RLDate },
      },
    }: {
      node: {
        data: RelationsGridData
      }
    }) => {
      if (RelationID === -1) {
        return { color: colors.red }
      }

      if (RLDateEnd || LKDate.from(RLDate) > LKDate.from(openDay)) {
        return { backgroundColor: colors.grey }
      }

      return {}
    },

    onRowDoubleClicked: ({ node: { data } }: { node: { data: RelationsGridData } }) => {
      const { ClientID, HashSum_ClientID_, ClientType } = data
      return history.push(`/secure/client/${ClientID}/details/${HashSum_ClientID_}/${ClientType}`)
    },

    getContextMenuItems: ({ node: { data } }: { node: { data: RelationsGridData } }) => {
      const { ID, HashSum_ClientID_, ClientID } = data

      return [
        {
          name: translateCmd('client_rl_del'),
          action: () => {
            openDeleteClientRelationModal(ID, HashSum_ClientID_, ClientID)
          },
          icon: 'detach',
          permissionKey: 'DELETE_CLIENT_RELATIONS',
          disabled: data.RelationID === -1,
        },
      ]
    },
  }
}

function mapDispatchToProps(dispatch: AppDispatch) {
  return {
    openDeleteClientRelationModal: (ID: number, hash: string, ClientID: number) => {
      dispatch(
        LKModalActions.openConfirmation(deleteClientRelationConfModal, {
          RLClientID: ID,
          RLHash: hash,
          ClientID,
        }),
      )
    },
  }
}

const mergeProps = (
  _stateProps: { [key: string]: any },
  {
    openDeleteClientRelationModal,
  }: { openDeleteClientRelationModal: (ID: number, hash: string, ClientID: number) => void },
  ownProps: RelationsGridProps,
) => {
  return {
    ...ownProps,
    ...config(openDeleteClientRelationModal, ownProps.openDay, ownProps.history),
  }
}

export default flowRight(
  withRouter,
  withLivedata('OpenDayStatus.Open_Day_Str as openDay'),
  connect(undefined, mapDispatchToProps, mergeProps),
)(LKGrid)
